// Copyright (c) Ping. All rights reserved.
//
// Input/output device picker — Figma DS "Voice menu" (4389:98465). Lists the
// devices for a kind (mic / camera / speaker) and switches the live track via
// LiveKit's switchActiveDevice. The selected row is highlighted.

import { useEffect, useState } from 'react';
import { Pressable, Text, View } from 'react-native';

import { Check } from 'lucide-react-native';

import { useCallStore } from '@calls/store/callStore';

export function DeviceMenu({
  kind,
  title,
  onClose,
}: {
  kind: MediaDeviceKind;
  title: string;
  onClose: () => void;
}): JSX.Element {
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);
  const [selected, setSelected] = useState<string>('');

  useEffect(() => {
    let alive = true;
    void useCallStore
      .getState()
      .listDevices(kind)
      .then((d) => {
        if (alive) setDevices(d);
      });
    return () => {
      alive = false;
    };
  }, [kind]);

  const choose = (id: string) => {
    setSelected(id);
    void useCallStore.getState().switchDevice(kind, id);
    onClose();
  };

  return (
    <View className="w-[253px] rounded-[12px] border border-light-border-secondary bg-light-surface-primary p-[4px] dark:border-dark-surface-pressed dark:bg-dark-surface-panel">
      <Text className="px-[12px] py-[6px] text-[12px] text-light-text-muted dark:text-[#6B7280]">{title}</Text>
      {devices.length === 0 ? (
        <Text className="px-[12px] py-[6px] text-[14px] text-light-text-muted dark:text-[#B5BAC3]">No devices</Text>
      ) : (
        devices.map((d) => (
          <Pressable
            key={d.deviceId}
            onPress={() => choose(d.deviceId)}
            className={`h-[36px] flex-row items-center justify-between rounded-[8px] px-[12px] active:bg-black/[0.05] dark:active:bg-white/[0.06] ${
              selected === d.deviceId ? 'bg-black/[0.04] dark:bg-white/[0.08]' : ''
            }`}
          >
            <Text numberOfLines={1} className="flex-1 text-[14px] text-light-text-primary dark:text-[#F5F6F8]">
              {d.label || 'Default'}
            </Text>
            {selected === d.deviceId ? <Check size={16} color="#537EFF" /> : null}
          </Pressable>
        ))
      )}
    </View>
  );
}
